exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* Colors */\n/* Borders */\n/* Media */\n/* \n    420px because it will not allow 3 buttons\n    at 30% with 10px margins to be displayed \n    on a single line.\n*/\n/* Common sizes */\n/* z indices */\n.cs-Impersonation {\n  padding: 2em;\n  width: 100%;\n}\n.cs-Impersonation__user-list {\n  padding: 0;\n  list-style: none;\n}\n.cs-impersonation__top {\n  border: 1px solid #ccc;\n  padding: 0 2em;\n}\n.cs-Impersonation__top-box {\n  margin: 15px;\n}\n.cs-Impersonation__top-box--first {\n  color: #888;\n  font-size: 0.95em;\n}\n.cs-Impersonation__top-box__currently {\n  display: inline-block;\n  margin-right: 1em;\n}\n.cs-Impersonation__top-box__currently__name {\n  display: inline-block;\n  margin-left: .5em;\n}\n.cs-Impersonation__stop {\n  font-size: .8em;\n}\n.cs-Impersonation__top-box__filter {\n  display: inline-block;\n  max-width: 20em;\n  margin-left: 1em;\n}\n.cs-Impersonation__no-matches {\n  text-align: center;\n  font-size: 1.3em;\n  font-style: italic;\n  padding: 20px;\n  color: #888;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/Impersonation/Impersonation.less
// module id = 978
// module chunks = 0